/**
 * eslint-disable jsx-a11y/alt-text
 *
 * @format
 */

/* eslint-disable react/jsx-no-target-blank */
import Config, { SSO_META } from "config";
import { UserRole } from "interfaces";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "reducer/store";
import { api } from "services";
import ui from "services/ui";

export default function Home() {
  const [star, setStar] = useState<number>(0);
  const [tmpStar, setTmpStar] = useState<number>(0);
  const user = useSelector((state: RootState) => state.user);
  const [feedback, setFeedback] = useState<string>("");
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  async function sendRate() {
    if (!user?.id) {
      return ui.alertFailed("You must login first", "");
    }
    if (!star || !feedback) {
      ui.alertFailed("Please enter star and feedback", "");
      return;
    }
    let rs = await api.post("/support-rate/create-rate", {
      star,
      feedback,
    });
    setStar(rs.star);
    setTmpStar(rs.star);
    setFeedback(rs.feedback);
    ui.alertSuccess("Thank you for your rate", "");
  }
  useEffect(() => {
    if (!user?.id) {
      return;
    }
    async function loadRate() {
      return;
      let rs = await api.post("/support-rate/get-my-rate", {});
      setTmpStar(rs?.star || 0);
      setStar(rs?.star || 0);
      setFeedback(rs?.feedback || "");
    }
    loadRate();
  }, [user?.id]);
  return (
    <div>
      <div className="container mx-auto pb-24 text-[#9f9ca7]">
        <div className="flex gap-8">
          <div
            className="w-1/3 p-8 text-white rounded-3xl relative"
            style={{ backgroundColor: "#101010", minHeight: 600 }}
          >
            <h3 className="w-full text-left font-bold text-2xl mt-8 text-gra">
              ERAGON
              <br /> Feedback and Support Center
            </h3>
            <img src="robot.png" className="absolute bottom-0" />
          </div>
          <div className="text-center mx-auto  w-2/3 flex flex-col gap-8">
            <div
              className="bg-white w-full mx-auto px-8 py-16 rounded-3xl"
              style={{ backgroundColor: "#101010" }}
            >
              <p className="mt-10 text-white">
                If you are satisfied with the game let give us some rating stars
              </p>
              <div id="rate" className="flex justify-center mt-14">
                {Array.from({ length: 5 }).map((e: any, index: number) => {
                  if (index < tmpStar) {
                    return (
                      <div
                        className="px-2 inline cursor-pointer"
                        onMouseEnter={() => {
                          setTmpStar(index + 1);
                        }}
                        onMouseLeave={() => {
                          setTmpStar(star);
                        }}
                        onClick={() => {
                          setStar(index + 1);
                          setCanSubmit(true);
                        }}
                      >
                        <img src="img/star-fill.png" className="w-10 h-10" />
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="px-2 inline cursor-pointer"
                        onMouseEnter={() => {
                          setTmpStar(index + 1);
                        }}
                        onMouseLeave={() => {
                          setTmpStar(star);
                        }}
                        onClick={() => {
                          setStar(index + 1);
                          setCanSubmit(true);
                        }}
                      >
                        <img src="img/star-empty.png" className="w-10 h-10" />
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            <div
              style={{ backgroundColor: "#101010" }}
              className="p-4  rounded-3xl"
            >
              <p className="mt-8 text-left text-white">
                If not please tell us how we can improve
              </p>
              <textarea
                style={{ backgroundColor: "#1b1a1e" }}
                onChange={(evt: any) => {
                  setFeedback(evt.target.value);
                  setCanSubmit(true);
                }}
                rows={8}
                value={feedback}
                className=" text-white border-0 w-full p-3 block mx-auto rounded-md  border-[#EBEBEB] ring-0 mt-4 placeholder-[#777]"
                default-value=""
                placeholder="Please tell us your opinion!"
              ></textarea>
              <div className="flex justify-end">
                <button
                  onClick={() => {
                    sendRate();
                  }}
                  className={`bg-[#82837E] text-white p-2 block  font-semibold  w-36 mt-4 rounded-3xl`}
                >
                  Send
                </button>
              </div>
              <div className="h-[1px] bg-[#DDDDDD] mt-4"></div>
              <div className="flex gap-2 mt-6">
                <p className="mt-4 text-left">Need direct support ?</p>
                {user?.id && (
                  <Link to="/your-ticket">
                    <p className="text-[#00fbf9]">
                      Keep track or create Support ticket
                    </p>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
